import { render, staticRenderFns } from "./70.vue?vue&type=template&id=60537d91&scoped=true&"
var script = {}
import style0 from "./70.vue?vue&type=style&index=0&id=60537d91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60537d91",
  null
  
)

export default component.exports